<template>
    <Tooltip ref="floaty" :placement="position" :triggers :disabled="isDisabled" class="tw-w-fit">
        <div v-if="activeWidth !== null" ref="content">
            <slot />
        </div>
        <slot v-else />

        <template #popper>
            <span v-if="label">{{ label }}</span>
            <slot v-else name="content" />
        </template>
    </Tooltip>
</template>

<script setup>
/**
 * <Tooltip label="I am the label when hovered"><button /></Tooltip>
 *
 * <Tooltip><button /> <template #content>I am the content when hovered</template></Tooltip>
 */
import 'floating-vue/dist/style.css';
import { Tooltip } from 'floating-vue';
import { computed, ref, useTemplateRef, watchEffect } from 'vue';
import { useElementSize } from '@vueuse/core';

const props = defineProps({
    position: {
        type: String,
        default: 'top',
    },
    label: {
        type: String,
        default: null,
        required: false,
    },
    triggers: {
        type: Array,
        default: () => ['hover'],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    alwaysOpen: {
        type: Boolean,
        default: false,
    },
    activeWidth: {
        type: Number,
        default: null,
    },
});

const floaty = useTemplateRef('floaty');
const content = useTemplateRef('content');
const { width: contentWidth } = useElementSize(content);
const triggers = ref(props.alwaysOpen ? [] : props.triggers);

const isDisabled = computed(() => {
    if (props.disabled) return true;
    if (props.activeWidth !== null) return contentWidth.value < props.activeWidth;
    return false;
});

watchEffect(() => {
    if (!isDisabled.value && props.alwaysOpen) {
        floaty.value.show();
    }
});
</script>
<style>
.v-popper__inner {
    max-width: 360px !important;
}
</style>
